import { useContext } from "react";
import { Box } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import { Loading } from "@analyticsMD/quil";
import MalnutritionAPIContext from "../../contexts/MalnutritionAPIContext";
import EmbededAppContainer from "../embedded-container";
import ErrorPage from "../error-page";
import MalnutritionSections from "./malnutrition-sections";
import theme from "../../theme";
import { Sizes } from "../../types/loadingSizes";

import type { FC, ReactNode } from "react";

interface MalnutritionCardContentProps {
  onClose?: () => void;
  onExpand?: () => void;
  closeButtonCmpt?: ReactNode;
}

const MalnutritionCardContent: FC<MalnutritionCardContentProps> = ({
  onClose,
  onExpand,
  closeButtonCmpt,
}) => {
  const { riskAssessmentQuery, weightsQuery } = useContext(
    MalnutritionAPIContext,
  );

  const queries = [riskAssessmentQuery, weightsQuery];
  const allSuccessful = queries.every((q) => q?.isSuccess);
  const anyErrors = queries.some((q) => q?.isError);

  const riskAssessmentData = riskAssessmentQuery.isSuccess
    ? riskAssessmentQuery.data
    : null;

  return (
    <ThemeProvider theme={theme}>
      <EmbededAppContainer>
        <Box sx={{ minWidth: "20rem" }}>
          {!allSuccessful && !anyErrors && (
            <Box sx={{ marginTop: "25%" }} data-testid="malnutrition-loading">
              <Loading message="Loading..." logoSize={Sizes.Medium} />
            </Box>
          )}
          {allSuccessful && !anyErrors && (
            <MalnutritionSections
              patient={riskAssessmentData ? riskAssessmentData.patient : null}
              status={riskAssessmentData ? riskAssessmentData.status : null}
              criteria={
                riskAssessmentData ? riskAssessmentData.criteria_met : null
              }
              weights={weightsQuery.isSuccess ? weightsQuery.data : null}
              onClose={onClose}
              onExpand={onExpand}
              closeButtonCmpt={closeButtonCmpt}
            />
          )}
          {anyErrors && (
            <ErrorPage
              error={
                new Error(
                  queries
                    .filter((q) => q?.isError)
                    .map((q) => String(q?.error))
                    .join(", "),
                )
              }
              closeButtonCmpt={closeButtonCmpt}
            />
          )}
        </Box>
      </EmbededAppContainer>
    </ThemeProvider>
  );
};

export default MalnutritionCardContent;
